export const scheduleData = [
  {
    day: 'On Thursday',
    appointments: [
      {
        id: 1,
        title: 'Health checkup complete',
        time: '11:00 AM',
        icon: '💉',
        bgColor: 'bg-[#dde2f9]'
      },
      {
        id: 2,
        title: 'Ophthalmologist',
        time: '14:00 PM',
        icon: '👁️',
        bgColor: 'bg-[#dde2f9]'
      }
    ]
  },
  {
    day: 'On Saturday',
    appointments: [
      {
        id: 3,
        title: 'Cardiologist',
        time: '12:00 AM',
        icon: '❤️',
        bgColor: 'bg-[#dde2f9]'
      },
      {
        id: 4,
        title: 'Neurologist',
        time: '16:00 PM',
        icon: '👨‍⚕️',
        bgColor: 'bg-[#dde2f9]'
      }
    ]
  }
]